import React, { Component, Fragment } from 'react';
import ReactDOM from 'react-dom';
import { saveAs } from 'file-saver';
import { translate } from 'react-i18next';
import { Icon } from 'react-icons-kit';
import { sort } from 'react-icons-kit/fa/sort';
import { ic_expand_less } from 'react-icons-kit/md/ic_expand_less';
import { ic_expand_more } from 'react-icons-kit/md/ic_expand_more';

import Info from 'components/Info/Info';
import Button from 'components/Button/Button';
import Warning from 'components/Warning/Warning';
import CheckBox from 'components/CheckBox/CheckBox';
import Download from 'components/Download/Download';
import TableRow from 'components/TableRow/TableRow';
import CustomModal from 'components/CustomModal/CustomModal';
import PrintSelection from 'components/PrintSelection/PrintSelection';
import Utils from 'utils/Utils';
import {
  removeCustomWMSLayer, removeAllCustomWMSLayer, isCustomWMSLayerActive, initCompareMap, setBbox,
  selectPrintArea, setCustomWMSLayerOpacity, addCustomWMSLayer, centerOnFotogram, getCenterOfGeometry,
  clearPrintLayer, getExtentByCoordinates,
} from 'utils/Visor';

import './List.css';

import RequestService from 'services/RequestService';
import ResourcesService from 'services/ResourcesService';

declare var ol;
declare var CONFIGURATIONS;

class List extends Component {
  constructor(props) {
    super(props);
    this.state = {
      fotograms: [],
      selected: [],
      selectedFullFeatures: [],
      asc: true,
      open: false,
      modalOption: undefined,
      selectedInfo: {},
      formats: [],
      collapsed: [],
      downloadData: [],
    };
  }

  componentWillMount() {
    this.loadFotograms(this.props.selectedFeatures, this.state.asc);
  }

  componentWillReceiveProps(nextProps) {
    if (this.props !== nextProps) {
      this.setState({ selectedFullFeatures: nextProps.selectedFullFeatures }, () => {
        this.loadFotograms(nextProps.selectedFeatures, this.state.asc);
      });
    }
  }

  loadFotograms = (fotograms, asc, callback) => {
    let res = fotograms.sort((a, b) => {
      const flight1 = this.getFlightOfFotogram(a);
      const flight2 = this.getFlightOfFotogram(b);
      const aux1 = flight1.title + ' ' + a.substring(a.lastIndexOf('\\') + 1, a.lastIndexOf('.'));
      const aux2 = flight2.title + ' ' + b.substring(b.lastIndexOf('\\') + 1, b.lastIndexOf('.'));
      return Utils.compareStrings(aux1, aux2);
    });

    if (asc === false) {
      res = res.reverse();
    }

    const newSelected = this.state.selected.filter((item) => {
      return res.indexOf(item) > -1;
    });

    this.setState({ fotograms: res, asc: asc, selected: newSelected }, () => {
      if (callback) {
        callback();
      }
    });
  }

  select = (id) => {
    let newSelected = [];
    if (this.state.selected.indexOf(id) > -1) {
      newSelected = this.state.selected.filter(item => item !== id);
    } else {
      newSelected = this.state.selected;
      newSelected.push(id);
    }

    this.setState({ selected: newSelected });
  }

  selectAll = () => {
    if (this.state.selected.length === this.state.fotograms.length) {
      this.setState({ selected: [] });
    } else {
      this.setState({ selected: this.state.fotograms });
    }
  }

  changeOpacity = (id, newOpacity) => {
    const fotograms = [].concat(this.state.fotograms);
    const fotogram = this.state.fotograms.indexOf(id) > -1 ? this.state.fotograms[this.state.fotograms.indexOf(id)] : undefined;
    if (fotogram !== undefined) {
      if (isCustomWMSLayerActive(fotogram)) {
        setCustomWMSLayerOpacity(fotogram, newOpacity);
      }
    }

    this.loadFotograms(fotograms, this.state.asc);
  }

  allFotogramsOpenedSameLayer = (fotogram) => {
    const selectedFullFeatures = this.state.selectedFullFeatures;
    let res = false;
    const fullFotogram = selectedFullFeatures.filter((item) => {
      return item.properties.fotogramas = fotogram;
    })[0];

    let opened = selectedFullFeatures.filter((item) => {
      return isCustomWMSLayerActive(item.properties.fotogramas);
    });

    if (opened.length > 0) {
      let layer = '';
      this.props.allFlights.forEach((flight) => {
        if (opened[0].properties.id_vuelo.indexOf(flight.name) > -1) {
          layer = flight.name;
        }
      });

      if (layer !== '') {
        let sameLayer = opened.filter((o) => {
          return o.properties.id_vuelo.indexOf(layer) > -1 && fullFotogram.properties.id_vuelo.indexOf(layer) > -1;
        });

        res = res || (opened.length === sameLayer.length);
      }
    } else {
      res = res || true;
    }

    return res;
  }

  changeOpened = (id) => {
    const _this = this;
    const fotograms = [].concat(this.state.fotograms);
    _this.setState({ open: true, modalOption: 'wait' }, () => {
      const fotogram = this.state.fotograms.indexOf(id) > -1 ? this.state.fotograms[this.state.fotograms.indexOf(id)] : undefined;
      if (fotogram !== undefined) {
        if (isCustomWMSLayerActive(fotogram)) {
          removeCustomWMSLayer(fotogram);
        } else {
          _this.props.block();
          if (!_this.allFotogramsOpenedSameLayer(fotogram)) {
            removeAllCustomWMSLayer();
          }

          const flight = _this.getFlightOfFotogram(fotogram);
          const centersFile = flight.resources.filter((r) => r.format.toLowerCase() === 'geojson' && r.name.indexOf('centroide_fotogramas') > -1)[0].url;
          Utils.getFile(centersFile).then((geojson) => {
            let coord = [];
            for (let feature of geojson.features) {
              if (feature.properties[CONFIGURATIONS.fotogram_layer_attr] === fotogram) {
                coord = feature.geometry.coordinates;
                break;
              }
            }

            _this.props.selectTempFlight(flight);
            const serviceUrl = flight.resources.filter((r) => r.format.toLowerCase() === 'wms')[0].url;
            addCustomWMSLayer(serviceUrl, fotogram, _this.props.unblock);
            centerOnFotogram(fotogram, coord);
          });
        }

        _this.setState({ open: false, modalOption: undefined }, () => {
          _this.loadFotograms(fotograms, _this.state.asc);
        });
      }
    });
  }

  sort = () => {
    const newSort = !this.state.asc;
    this.loadFotograms(this.state.fotograms, newSort);
  }

  deleteFotogram = (id) => {
    const _this = this;
    let fotogram = this.state.fotograms.indexOf(id) > -1 ? this.state.fotograms[this.state.fotograms.indexOf(id)] : undefined;
    if (fotogram !== undefined) {
      let newFotograms = this.state.fotograms.filter(item => item !== id);
      let newFullFeatures = this.state.selectedFullFeatures.filter(item => item.properties.fotogramas !== id);
      if (isCustomWMSLayerActive(fotogram)) {
        removeCustomWMSLayer(fotogram);
      }

      this.setState({ selected: [] }, () => {
        _this.loadFotograms(newFotograms, this.state.asc, () => {
          _this.props.selectFeatures(newFotograms, newFullFeatures);
        });
      });
    }
  }

  deleteAll = () => {
    const _this = this;
    if (this.state.selected.length > 0) {
      let ids = [];
      let newFotograms = this.state.fotograms.filter((item) => {
        if (this.state.selected.indexOf(item) > -1) {
          ids.push(item);
        }

        return this.state.selected.indexOf(item) < 0;
      });

      let newFullFeatures = this.state.selectedFullFeatures.filter((item) => {
        return this.state.selected.indexOf(item.properties.fotogramas) < 0;
      });

      newFotograms = Utils.sortArrayByProperty(newFotograms, 'name', this.state.asc);
      ids.forEach((fId) => {
        const fotogram = this.state.fotograms.indexOf(fId) > -1 ? this.state.fotograms[this.state.fotograms.indexOf(fId)] : undefined;
        if (fotogram !== undefined) {
          if (isCustomWMSLayerActive(fotogram)) {
            removeCustomWMSLayer(fotogram);
          }
        }
      });

      this.setState({ selected: [], collapsed: [] }, () => {
        _this.loadFotograms(newFotograms, this.state.asc, () => {
          _this.props.selectFeatures(newFotograms, newFullFeatures);
        });
      });
    } else {
      removeAllCustomWMSLayer();
      this.setState({ fotograms: [], selected: [], collapsed: [] }, () => {
        _this.props.selectTempFlight(undefined);
        _this.props.selectFeatures([], []);
      });
    }
  }

  onCloseModal = () => {
    this.setState({ open: false, modalOption: undefined, selectedInfo: {}, printSelected: {}, downloadData: [] });
  };

  certifyFotogram = (id) => {
    clearPrintLayer();
    this.props.block();
    const _this = this;
    const fotograms = [].concat(this.state.fotograms);
    const fotogram = this.state.fotograms.indexOf(id) > -1 ? this.state.fotograms[this.state.fotograms.indexOf(id)] : undefined;
    if (fotogram !== undefined) {
      const flight = _this.getFlightOfFotogram(fotogram);
      const centersFile = flight.resources.filter((r) => r.format.toLowerCase() === 'geojson' && r.name.indexOf('centroide_fotogramas') > -1)[0].url;
      Utils.getFile(centersFile).then((geojson) => {
        let coord = [];
        for (let feature of geojson.features) {
          if (feature.properties[CONFIGURATIONS.fotogram_layer_attr] === fotogram) {
            coord = feature.geometry.coordinates;
            break;
          }
        }

        const marksFile = flight.resources.filter((r) => r.format.toLowerCase() === 'geojson' && r.name.indexOf('huella_fotogramas') > -1)[0].url;
        Utils.getFile(marksFile).then((geojson) => {
          let extent = [];
          for (let feature of geojson.features) {
            if (feature.properties[CONFIGURATIONS.marks_layer_attr] === fotogram) {
              extent = getExtentByCoordinates(feature.geometry);
              break;
            }
          }

          _this.props.selectTempFlight(flight);
          if (!isCustomWMSLayerActive(fotogram)) {
            const url = flight.resources.filter((r) => r.format.toLowerCase() === 'wms')[0].url;
            addCustomWMSLayer(url, fotogram, _this.props.unblock);
            centerOnFotogram(fotogram, coord);
            setBbox(extent);
          } else {
            _this.props.unblock();
          }

          const printSelected = {
            fotogram: fotogram,
            extent: extent,
            center: coord,
          };

          _this.setState({ open: true, modalOption: 'print', printSelected: printSelected }, () => {
            _this.loadFotograms(fotograms, _this.state.asc);
          });
        });
      });
    } else {
      this.props.unblock();
    }
  }

  getFlightOfFotogram = (fotogram) => {
    let flightRes = {};
    const fullFeature = this.state.selectedFullFeatures.filter((item) => {
      const idFoto = item.properties.id_fotogra.split('-');
      idFoto.shift();
      return item.properties.id_fotogra !== undefined && (Utils.stringContainsString(idFoto.join('-'), fotogram) || Utils.stringContainsString(fotogram, idFoto.join('-')));
    });

    if (fullFeature.length > 0) {
      const flight = this.props.allFlights.filter((item) => {
        return Utils.stringContainsString(item.name, fullFeature[0].properties.id_vuelo);
      });

      if (flight.length > 0) {
        flightRes = flight[0];
      }
    }

    return flightRes;
  }

  downloadList = () => {
    const _this = this;
    this.props.block();
    const requests = [];
    const selectedData = [];
    this.state.selected.forEach((fotogram) => {
      requests.push(RequestService.getRequest(`${CONFIGURATIONS.ckan_url}/package_search?fq=vocab_tipo_datos:Foto*&q=*/${fotogram}.*`));
    })

    Promise.all(requests).then((responses) => {
      responses.forEach((response, index) => {
        let results = response.result.results;
        if (results.length > 1) {
          results = results.filter((item) => {
            let add = false;
            item.resources.forEach((r) => {
              add = add || (r.url.indexOf(`/${_this.state.selected[index]}.`) > -1);
            });

            return add;
          });
        }

        selectedData.push(results[0]);
      });

      this.props.unblock();
      this.setState({ open: true, modalOption: 'download', downloadData: selectedData });
    }).catch((err) => {
      this.props.unblock();
      this.setState({ open: true, modalOption: 'error-downloading' });
    });
  }

  showInfoFotogram = (id) => {
    const _this = this;
    this.props.block();
    RequestService.getRequest(`${CONFIGURATIONS.ckan_url}/package_search?fq=vocab_tipo_datos:Foto*&q=*/${id}.*`).then((response) => {
      let results = response.result.results;
      if (results.length > 1) {
        results = results.filter((item) => {
          let add = false;
          item.resources.forEach((r) => {
            add = add || (r.url.indexOf(`/${id}.`) > -1);
          });

          return add;
        });
      }

      _this.props.unblock();
      if (results.length > 0) {
        _this.setState({ open: true, modalOption: 'info', selectedInfo: results[0] });
      }
    }).catch((err) => {
      _this.props.unblock();
      _this.setState({ open: true, modalOption: 'error-info' });
    });
  }

  collapse = (flightId) => {
    let newCollapsed = [];
    if (this.state.collapsed.indexOf(flightId) > -1) {
      newCollapsed = this.state.collapsed.filter((id) => id !== flightId);
    } else {
      newCollapsed.push(flightId);
      newCollapsed = newCollapsed.concat(this.state.collapsed);
    }

    this.setState({ collapsed: newCollapsed });
  }

  compareSelected = () => {
    const { t } = this.props;
    let features = this.state.selectedFullFeatures.filter((item) => {
      return this.state.selected.indexOf(item.properties.fotogramas) > -1;
    });

    this.setState({ open: true, modalOption: 'compare' }, () => {
      document.querySelector('.modalOverlay').style.padding = '0px';
      document.querySelector('.modalOverlay > div').style.minWidth = '100vw';
      document.querySelector('.modalOverlay > div').style.minHeight = '100vh';
      const maps = [];
      const width = features.length === 2 ? 'calc(50% - 4px)' : features.length === 4 ? 'calc(100% - 4px)' : 'calc(33.33% - 4px)';
      const height = features.length > 3 ? 'calc(50vh - 30px - 1.2rem)' : 'calc(100vh - 51px - 2.4rem)';
      features.forEach((f, i) => {
        const flight = this.getFlightOfFotogram(f.properties.fotogramas);
        maps.push(
          <div className='compare-map' key={'map' + i} id={'map' + i} style={{ width, height }}>
            <p><b>{t('list.flight') + ': '}</b>{flight.title + ' | '}<b>{t('list.fotogram') + ': '}</b>{f.properties.fotogramas}</p>
          </div>
        );
      });

      let content = <React.Fragment>{maps}</React.Fragment>;
      if (maps.length > 3) {
        content = <React.Fragment>
          <div style={{ width: '50%' }}>{maps.slice(0, 2)}</div>
          <div style={{ width: '50%' }}>{maps.slice(2, 4)}</div>
        </React.Fragment>;
      }

      ReactDOM.render(content, document.getElementById('compareContainer'));
      setTimeout(() => {
        const flight = this.getFlightOfFotogram(features[0].properties.fotogramas);
        const marksFile = flight.resources.filter((r) => r.format.toLowerCase() === 'geojson' && r.name.indexOf('huella_fotogramas') > -1)[0].url;
        Utils.getFile(marksFile).then((geojson) => {
          let extent = [];
          for (let f of geojson.features) {
            if (f.properties[CONFIGURATIONS.marks_layer_attr] === features[0].properties.fotogramas) {
              extent = getExtentByCoordinates(f.geometry);
              break;
            }
          }

          const maps = [];
          features.forEach((f, i) => {
            const flight = this.getFlightOfFotogram(f.properties.fotogramas);
            const url = flight.resources.filter((r) => r.format.toLowerCase() === 'wms')[0].url;
            let coords = f.geometry !== undefined ? ol.proj.fromLonLat(f.geometry.coordinates, 'EPSG:25830') : f.properties.geometry.flatCoordinates;
            if (f.geometry !== undefined && Utils.stringContainsString(f.geometry.type, 'polygon')) {
              coords = getCenterOfGeometry(f.geometry);
            }

            const m = initCompareMap('map' + i, url, f.properties.fotogramas, coords, i === 0, extent);
            maps.push(m);
          });

          maps.forEach((m) => {
            const associated = maps.filter((fm) => {
              return fm.getTarget() !== m.getTarget();
            });

            m.addInteraction(new ol.interaction.Synchronize({ maps: associated }));
          });
        });
      }, 1000);
    });
  }

  acceptPrint = (scale, template, certify) => {
    let printSelected = this.state.printSelected;
    let size = [0, 0];
    if (Utils.stringContainsString(template, 'a3 horizontal')) {
      size = [42.0, 29.7];
    } else if (Utils.stringContainsString(template, 'a3 vertical')) {
      size = [29.7, 42.0];
    } else if (Utils.stringContainsString(template, 'a4 horizontal')) {
      size = [29.7, 21.0];
    } else if (Utils.stringContainsString(template, 'a4 vertical')) {
      size = [21.0, 29.7];
    } else {
      const sizes = template.split('x');
      size = [parseInt(sizes[0], 10), parseInt(sizes[1], 10)];
    }

    printSelected.template = template;
    printSelected.scale = scale;
    printSelected.certify = certify;
    selectPrintArea(scale, printSelected.center, size, printSelected.extent, this.sendToPrint);
    this.setState({ open: false, modalOption: undefined, printSelected: printSelected });
  }

  sendToPrint = (center) => {
    const _this = this;
    if (center !== null) {
      _this.props.block();
      const printSelected = _this.state.printSelected;
      const fotogram = this.state.fotograms.indexOf(printSelected.fotogram) > -1 ? this.state.fotograms[this.state.fotograms.indexOf(printSelected.fotogram)] : undefined;
      const name = printSelected.fotogram.substring(printSelected.fotogram.lastIndexOf('\\') + 1, printSelected.fotogram.length);
      const flight = _this.getFlightOfFotogram(fotogram);
      // const url = flight.resources.filter((r) => r.format.toLowerCase() === 'wms')[0].url;      
      const wmsResource = flight.resources.filter(r => r.format.toLowerCase() === 'wms')[0];
      const rawUrl = wmsResource && wmsResource.url ? wmsResource.url : '';
      const url = rawUrl.split('?')[0]; // ← recorta hasta el '?'
      const data = {
        flightDate: flight.extras.filter((e) => e.key === 'Fecha')[0].value.toLowerCase(),
        flightScale: flight.extras.filter((e) => e.key === 'Escala')[0].value.toLowerCase(),
        flightName: flight.title,
        province: '-',
        township: '-',
      };

      RequestService.getRequest(`${CONFIGURATIONS.ckan_url}/package_search?fq=vocab_tipo_datos:Foto*&q=*/${fotogram}.*`).then((response) => {
        let results = response.result.results;
        if (results.length > 1) {
          results = results.filter((item) => {
            let add = false;
            item.resources.forEach((r) => {
              add = add || (r.url.indexOf(`/${fotogram}.`) > -1);
            });

            return add;
          });
        }

        if (results.length > 0) {
          data.province = results[0].extras.filter((e) => e.key === 'Provincia')[0].value;
          data.township = results[0].extras.filter((e) => e.key === 'Municipio')[0].value;
          data.flightDate = results[0].extras.filter((e) => e.key === 'Fecha Fotograma')[0].value;
          _this.finalPrint(center, printSelected, fotogram, name, flight, url, data);
        } else {
          _this.finalPrint(center, printSelected, fotogram, name, flight, url, data);
        }
      }).catch((err) => {
        _this.finalPrint(center, printSelected, fotogram, name, flight, url, data);
      });

      /*const addressUrl = 'http://www.cartociudad.es/wps/WebProcessingService?';
      const coords = toLonLat(center);
      let canceled = false;
      const timeout = setTimeout(() => {
        canceled = true;
        _this.finalPrint(center, printSelected, fotogram, name, flight, url, data);
      }, CONFIGURATIONS.cancel_request_timeout);

      RequestService.postXMLRequest(addressUrl, ResourcesService.getRevergeGeocoderRequest(coords[0], coords[1]))
      .then((response) => {
        if (!canceled) {
          clearTimeout(timeout);
          const text = response.data;
          if (text.indexOf('<n52:municipality>') > -1) {
            data.township = text.split('<n52:municipality>')[1].split('</n52:municipality>')[0].trim();
          }

          if (text.indexOf('<n52:province>') > -1) {
            data.province = text.split('<n52:province>')[1].split('</n52:province>')[0].trim();
          }

          _this.finalPrint(center, printSelected, fotogram, name, flight, url, data);
        }
      }).catch((error) => {
        if (!canceled) {
          clearTimeout(timeout);
          _this.finalPrint(center, printSelected, fotogram, name, flight, url, data);
        }
      });*/
    } else {
      _this.setState({ printSelected: {}, open: true, modalOption: 'error-area-selected' });
    }
  }

  finalPrint = (center, printSelected, fotogram, name, flight, url, data) => {
    const _this = this;
    const nameFile = `print_${Utils.formatPrintDate()}.pdf`;
    const request = ResourcesService.getPrintRequest(url, name.split('.')[0], name, center, printSelected.scale, printSelected.template, data.flightDate, data.flightScale, data.flightName, data.province, data.township);
    RequestService.postRequest(CONFIGURATIONS.print_url + CONFIGURATIONS.print_path, request)
      .then((response) => {
        const urlStatus = CONFIGURATIONS.print_url + response.data.statusURL.replace("/geoprint", "");
        const urlDownload = CONFIGURATIONS.print_url + response.data.downloadURL.replace("/geoprint", "");
        let finished = false;
        let interval = setInterval(() => {
          if (!finished) {
            RequestService.getRequest(urlStatus)
              .then((response) => {
                finished = response.done && response.status === 'finished';
                if (finished) {
                  clearInterval(interval);
                  _this.downloadPrintFile(printSelected.certify, urlDownload, nameFile);
                } else if (response.done) {
                  clearInterval(interval);
                  _this.props.unblock();
                  _this.setState({ printSelected: {}, open: true, modalOption: 'error-printing' });
                }
              }).catch((error) => {
                clearInterval(interval);
                _this.props.unblock();
                _this.setState({ printSelected: {}, open: true, modalOption: 'error-printing' });
              });
          } else {
            clearInterval(interval);
            _this.downloadPrintFile(printSelected.certify, urlDownload, nameFile);
          }
        }, 2000);
      }).catch((error) => {
        _this.props.unblock();
        _this.setState({ printSelected: {}, open: true, modalOption: 'error-printing' });
      });
  }

  downloadPrintFile = (certify, urlDownload, nameFile) => {
    const _this = this;
    if (certify) {
      const data = {
        name_file: nameFile,
        file_url: urlDownload,
      };

      RequestService.postRequestFile(CONFIGURATIONS.api_rest + 'api/sign-pdf', data).then((response) => {
        const file = new Blob([response.data], { type: 'application/pdf' });
        _this.props.unblock();
        saveAs(file, nameFile);
      }).catch((err) => {
        console.error(err);
        _this.props.unblock();
        _this.setState({ printSelected: {}, open: true, modalOption: 'error-printing' });
      });
    } else {
      const link = document.createElement('a');
      link.href = urlDownload;
      link.download = nameFile;
      document.body.appendChild(link);
      link.click();
      this.props.unblock();
      document.body.removeChild(link);
    }
  }

  render() {
    const { t } = this.props;
    const { open, modalOption, downloadData } = this.state;
    let fotograms = [];
    if (this.state.fotograms.length > 0) {
      let firstFlight = {};
      for (let i = 0; i < this.state.fotograms.length; i++) {
        const f = this.state.fotograms[i];
        const fotogramFlight = this.getFlightOfFotogram(f);
        if (firstFlight.id !== fotogramFlight.id) {
          fotograms.push(
            <tr className='tableRow' key={'flight' + fotogramFlight.title}>
              <td colSpan={4} className='flightTableRow clickable' onClick={this.collapse.bind(null, fotogramFlight.id)}>
                {fotogramFlight.title}
                {this.state.collapsed.indexOf(fotogramFlight.id) === -1 ?
                  <span className='collapse-icon'><Icon size={'1.5rem'} icon={ic_expand_less} /></span>
                  : <span className='collapse-icon'><Icon size={'1.5rem'} icon={ic_expand_more} /></span>}
              </td>
            </tr>
          );
        }

        if (this.state.collapsed.indexOf(fotogramFlight.id) === -1) {
          fotograms.push(<TableRow key={'f' + i} data={f} select={this.select.bind(null, f)} flight={fotogramFlight}
            isSelected={this.state.selected.indexOf(f) > -1} certifyFotogram={this.certifyFotogram.bind(null, f)}
            openHideFotogram={this.changeOpened.bind(null, f)} changeOpacity={this.changeOpacity.bind(null, f)}
            deleteFotogram={this.deleteFotogram.bind(null, f)} showInfoPopup={this.showInfoFotogram.bind(null, f)} />);
        }

        firstFlight = fotogramFlight;
      }
    }

    return (
      <Fragment>
        <div className='listContainer'>
          <div className='listTitleContainer row'><span>{t('list.my_list') + ' '} ({this.state.fotograms.length})</span></div>
          {this.state.fotograms.length > 0 ?
            <Fragment>
              <div className='table row'>
                <div style={{ overflowY: 'auto', overflowX: 'hidden', maxHeight: 'calc(100vh - 750px)', width: '430px', minHeight: '100px' }}>
                  <table style={{ borderCollapse: 'collapse', width: '420px' }}>
                    <thead>
                      <tr className='tableRowHeader'>
                        <th className='tableCell'><CheckBox onClick={this.selectAll} isSelected={this.state.selected.length === this.state.fotograms.length} all={true} /></th>
                        <th className='tableCell'>{t('list.fotograms')}
                          <span className='sortButton' onClick={this.sort}>
                            <Icon size={'12px'} icon={sort} />
                          </span>
                        </th>
                        <th className='tableCell'>{t('list.opacity')}</th>
                        <th className='tableCell'>{t('list.actions')}</th>
                      </tr>
                    </thead>
                    <tbody>
                      {fotograms}
                    </tbody>
                  </table>
                </div>
              </div>
              {this.state.selected.length > 0 ?
                <div className='row'>
                  <p style={{ width: '100%', marginTop: '0rem', marginBottom: '2rem', fontSize: '12px' }}>{t('list.selected') + ': '}<b>{this.state.selected.length}</b></p>
                </div>
                : null}
              <div className='listButtonsContainer row'>
                <Button text={t('list.remove')} active={this.state.selected.length > 0} onClick={this.deleteAll} />
                <Button text={t('list.download')} active={this.state.selected.length > 0} onClick={this.downloadList} />
                <Button text={t('list.compare')} active={this.state.selected.length > 1 && this.state.selected.length < 5} onClick={this.compareSelected} />
              </div>
            </Fragment>
            : null}
        </div>
        {modalOption === 'print' ?
          <CustomModal open={open} onClose={this.onCloseModal} title={t('list.print')}>
            <PrintSelection acceptPrint={this.acceptPrint} />
          </CustomModal>
          : modalOption === 'info' ?
            <CustomModal open={open} onClose={this.onCloseModal} title={t('list.info')}>
              <Info variant='fotogram' data={this.state.selectedInfo} />
            </CustomModal>
            : modalOption === 'download' ?
              <CustomModal open={open} onClose={this.onCloseModal} title={t('list.download_fotograms')}>
                <Download data={downloadData} />
              </CustomModal>
              : modalOption === 'compare' ?
                <CustomModal open={open} onClose={this.onCloseModal} title={t('list.compare_fotograms')}>
                  <div id='compareContainer' className='compare-container'>
                  </div>
                </CustomModal>
                : <CustomModal open={open} onClose={this.onCloseModal}>
                  <Warning>
                    {modalOption === 'wait' ?
                      <p style={{ width: '160px', textAlign: 'center' }}>{t('list.please_wait')}</p>
                      : modalOption === 'error-area-selected' ?
                        <p style={{ width: '160px', textAlign: 'center' }}>{t('list.not_area')}</p>
                        : modalOption === 'error-printing' ?
                          <p style={{ width: '160px', textAlign: 'center' }}>{t('list.error')}</p>
                          : modalOption === 'error-downloading' ?
                            <p style={{ width: '160px', textAlign: 'center' }}>{t('list.download_error')}</p>
                            : modalOption === 'error-info' ?
                              <p style={{ width: '160px', textAlign: 'center' }}>{t('list.info_error')}</p>
                              : null}
                  </Warning>
                </CustomModal>}
      </Fragment>
    );
  }
}

export default translate()(List);
